import { AlignType } from 'common/types/styleTypes'
import { useCalculateHeadingFontSize } from './use-calculate-heading-font-size'
import { useCalculateHeadingLineHeight } from './use-calculate-heading-line-height'
import { useCalculateHeadingTextAlign } from './use-calculate-heading-text-align'
import { useCalculateHeadingLetterSpacing } from './use-calculate-heading-letter-spacing'
import { useCalculateHeadingFontFamily } from './use-calculate-heading-font-family'
import { useCalculateHeadingFontStyle } from './use-calculate-heading-font-style'
import { useCalculateHeadingFontWeight } from './use-calculate-heading-font-weight'

export const useCalculateHeadingTypography = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  fontFamily,
  mobileFontFamily,
  fontStyle,
  mobileFontStyle,
  fontWeight,
  mobileFontWeight,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
} = {}) => {
  const returnUseCalculateHeadingFontFamily = useCalculateHeadingFontFamily({
    fontFamily,
    mobileFontFamily,
  })

  const returnUseCalculateHeadingFontStyle = useCalculateHeadingFontStyle({
    fontStyle,
    mobileFontStyle,
  })

  const returnUseCalculateHeadingFontWeight = useCalculateHeadingFontWeight({
    fontWeight,
    mobileFontWeight,
  })

  const returnUseCalculateHeadingFontSize = useCalculateHeadingFontSize({
    fontSize,
    mobileFontSize,
  })

  const returnUseCalculateHeadingLineHeight = useCalculateHeadingLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
  })

  const returnUseCalculateHeadingTextAlign = useCalculateHeadingTextAlign({
    textAlign,
    mobileTextAlign,
  })

  const returnUseCalculateHeadingLetterSpacing =
    useCalculateHeadingLetterSpacing({
      letterSpacing,
      mobileLetterSpacing,
    })

  return {
    ...returnUseCalculateHeadingFontSize,
    ...returnUseCalculateHeadingLineHeight,
    ...returnUseCalculateHeadingTextAlign,
    ...returnUseCalculateHeadingLetterSpacing,
    ...returnUseCalculateHeadingFontFamily,
    ...returnUseCalculateHeadingFontStyle,
    ...returnUseCalculateHeadingFontWeight,
  }
}
